import React from "react"
import FlexBox from "@/components/layout/FlexBox"
import LoadingCounter from "@/components/LoadingCounter"
import {useTheme} from "@/hooks/useTheme"

const Loading = ({
                   loadingMessage,
                   withCounter,
                   showSubMessage = true
                 }) => {
  const theme = useTheme()
  const sizeValue = 192

  const styles = {
    message1: {
      fontSize: 18,
      fontWeight: 400,
      color: theme.fontColor4,
      textAlign: 'center'
    },
    message2: {
      fontSize: 15,
      fontWeight: 400,
      color: theme.fontColor4,
      textAlign: 'center'
    }
  }

  const topMargin = "24px"

  return (
    <FlexBox column centered flexGrow>
      <FlexBox style={{marginTop: topMargin}}>
        <LoadingCounter
          useCounter={withCounter}
          size={sizeValue}
        />
      </FlexBox>

      {loadingMessage && (
        <FlexBox style={styles.message1}>{loadingMessage}</FlexBox>
      )}

      {showSubMessage && (
        <FlexBox style={styles.message2}>This may take a few seconds...</FlexBox>
      )}
    </FlexBox>
  )
}

export default Loading
